import { useEffect, useCallback } from 'react';

export function useKeyboardShortcuts(shortcuts) {
  const handleKeyDown = useCallback((e) => {
    // Skip if no key or typing in input fields (unless explicitly allowed)
    if (!e.key) return;
    
    const activeElement = document.activeElement;
    const isInputField = ['INPUT', 'TEXTAREA', 'SELECT'].includes(activeElement?.tagName);
    
    for (const shortcut of shortcuts) {
      if (isInputField && !shortcut.allowInInput) continue;
      if (!shortcut.key) continue;
      
      const keyMatch = e.key?.toLowerCase() === shortcut.key?.toLowerCase();
      const ctrlMatch = shortcut.ctrl ? (e.ctrlKey || e.metaKey) : !e.ctrlKey && !e.metaKey;
      const altMatch = shortcut.alt ? e.altKey : !e.altKey;
      const shiftMatch = shortcut.shift ? e.shiftKey : !e.shiftKey;
      
      if (keyMatch && ctrlMatch && altMatch && shiftMatch) {
        e.preventDefault();
        shortcut.action();
        break;
      }
    }
  }, [shortcuts]);

  useEffect(() => {
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [handleKeyDown]);
}
